var _defs, _path, _g, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingleProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "single-product_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193.21 122.65"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "single-product_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "single-product_svg__cls-1",
    d: "M456.35 23.39h9l-4.5 5-4.5-5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "single-product_svg__clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "single-product_svg__cls-1",
    d: "M456.35 49.38h9l-4.5 5-4.5-5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "single-product_svg__clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "single-product_svg__cls-1",
    d: "M516.35 23.39h9l-4.5 5-4.5-5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "single-product_svg__clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "single-product_svg__cls-1",
    d: "M516.35 49.38h9l-4.5 5-4.5-5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "single-product_svg__clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "single-product_svg__cls-1",
    d: "M576.35 23.39h9l-4.5 5-4.5-5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "single-product_svg__clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "single-product_svg__cls-1",
    d: "M576.35 49.38h9l-4.5 5-4.5-5z"
  })), /*#__PURE__*/React.createElement("style", null, ".single-product_svg__cls-1,.single-product_svg__cls-11,.single-product_svg__cls-4,.single-product_svg__cls-6{fill:none}.single-product_svg__cls-3{fill:#dbdbdb}.single-product_svg__cls-11,.single-product_svg__cls-4{stroke:#707070}.single-product_svg__cls-5{fill:#fff}.single-product_svg__cls-6{stroke:#c4c4c4}.single-product_svg__cls-7{fill:#a3cb63}.single-product_svg__cls-11{stroke-width:3px}"))), /*#__PURE__*/React.createElement("g", {
    id: "single-product_svg__Group_68119",
    "data-name": "Group 68119"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9b9b9b",
    fill: "none",
    d: "M8.1 5.33h177v112H8.1z",
    id: "single-product_svg__Rectangle_28859",
    "data-name": "Rectangle 28859"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "single-product_svg__Group_68057",
    "data-name": "Group 68057"
  }, /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Rectangle_28861",
    "data-name": "Rectangle 28861",
    className: "single-product_svg__cls-3",
    d: "M16.6 8.83h111a3 3 0 013 3v28h-117v-28a3 3 0 013-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Line_259",
    "data-name": "Line 259",
    className: "single-product_svg__cls-4",
    d: "M54.1 34.33h40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Line_260",
    "data-name": "Line 260",
    className: "single-product_svg__cls-4",
    d: "M21.1 50.33h103.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Line_261",
    "data-name": "Line 261",
    className: "single-product_svg__cls-4",
    d: "M21.1 61.1h103.86"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "single-product_svg__Ellipse_47",
    "data-name": "Ellipse 47",
    className: "single-product_svg__cls-5",
    cx: 72.6,
    cy: 22.83,
    r: 9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "single-product_svg__Group_68117",
    "data-name": "Group 68117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "single-product_svg__Rectangle_28867",
    "data-name": "Rectangle 28867"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "single-product_svg__cls-5",
    x: 20.6,
    y: 68.83,
    width: 33,
    height: 42,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "single-product_svg__cls-6",
    x: 21.1,
    y: 69.33,
    width: 32,
    height: 41,
    rx: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Line_271",
    "data-name": "Line 271",
    className: "single-product_svg__cls-4",
    d: "M25.1 75.33h22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Line_272",
    "data-name": "Line 272",
    className: "single-product_svg__cls-4",
    d: "M25.1 81.33h22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Line_273",
    "data-name": "Line 273",
    className: "single-product_svg__cls-4",
    d: "M25.1 85.33h22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Rectangle_28868",
    "data-name": "Rectangle 28868",
    className: "single-product_svg__cls-3",
    d: "M20.6 89.83h33v9h-33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Rectangle_28869",
    "data-name": "Rectangle 28869",
    className: "single-product_svg__cls-7",
    d: "M35.6 101.83h16v6h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Line_274",
    "data-name": "Line 274",
    className: "single-product_svg__cls-4",
    d: "M42.1 94.33h9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "single-product_svg__Ellipse_49",
    "data-name": "Ellipse 49"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "single-product_svg__cls-7",
    cx: 52.6,
    cy: 70.83,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.6,
    cy: 70.83,
    r: 3.5,
    stroke: "#fff",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "single-product_svg__Group_68118",
    "data-name": "Group 68118"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "single-product_svg__Rectangle_28860",
    "data-name": "Rectangle 28860"
  }, /*#__PURE__*/React.createElement("path", {
    className: "single-product_svg__cls-5",
    d: "M136.6 8.83h39a3 3 0 013 3v103h-45v-103a3 3 0 013-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "single-product_svg__cls-6",
    d: "M136.6 9.33h39a2.5 2.5 0 012.5 2.5v102a.5.5 0 01-.5.5h-43a.51.51 0 01-.5-.5v-102a2.5 2.5 0 012.5-2.5z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Rectangle_28870",
    "data-name": "Rectangle 28870",
    className: "single-product_svg__cls-3",
    d: "M133.6 89.83h44v9h-44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Rectangle_28871",
    "data-name": "Rectangle 28871",
    fill: "#0e5a7b",
    d: "M158.6 103.83h16v6h-16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Rectangle_28872",
    "data-name": "Rectangle 28872",
    fill: "#bb5360",
    d: "M137.6 103.83h16v6h-16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Path_56515",
    "data-name": "Path 56515",
    className: "single-product_svg__cls-11",
    d: "M165.7 94.33h9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Path_56516",
    "data-name": "Path 56516",
    className: "single-product_svg__cls-4",
    d: "M137.7 94.33h9"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(137.6 19.83)",
    style: {
      isolation: "isolate"
    },
    fontSize: 8,
    fill: "#333",
    fontFamily: "Lato-Bold,Lato",
    fontWeight: 700,
    id: "single-product_svg__Cart"
  }, "Cart"), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Line_275",
    "data-name": "Line 275",
    className: "single-product_svg__cls-4",
    d: "M138.1 26.33h35"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Line_276",
    "data-name": "Line 276",
    className: "single-product_svg__cls-4",
    d: "M138.1 32.33h35"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Line_277",
    "data-name": "Line 277",
    className: "single-product_svg__cls-11",
    d: "M138.1 47.33h18"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Line_281",
    "data-name": "Line 281",
    className: "single-product_svg__cls-11",
    d: "M138.1 63.33h14"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Line_278",
    "data-name": "Line 278",
    className: "single-product_svg__cls-4",
    d: "M138.1 53.33h25"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Line_279",
    "data-name": "Line 279",
    className: "single-product_svg__cls-4",
    d: "M138.1 58.33h25"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "single-product_svg__Line_280",
    "data-name": "Line 280",
    stroke: "#dbdbdb",
    fill: "none",
    d: "M138.1 71.33h35"
  })))));
}
export default SvgSingleProduct;